import classNames from "classnames";
import React from "react";

import "./roadData.css";

export default function RoadData(props) {
  const { pavementDetails, hazardRating, alignmentDetails } = props;
  const {
    leftUnsealed,
    leftSealed,
    sealWidth,
    laneCount,
    rightSealed,
    rightUnsealed,
  } = pavementDetails ?? {};
  const { left: leftHazardRating, right: rightHazardRating } =
    hazardRating ?? {};
  const {
    verticalCurveType,
    gradePercent,
    verticalDesignSpeed,
    horizontalProfile,
    curveRadius,
    calculatedSafeSpeed,
    crossfall,
  } = alignmentDetails ?? {};

  return (
    <div className="roadData">
      <div className="section" style={{ flexBasis: "35%" }}>
        {props.pavementDetailsLoading ? (
          <div>Loading Data...</div>
        ) : (
          <>
            <div className="infoGrouping">
              <label>Left Shoulder</label>
              <div className="data">
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Unsealed</label>
                  </div>
                  <div className="gridItem">
                    <span>
                      {leftUnsealed != null ? `${leftUnsealed}m` : null}
                    </span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Sealed</label>
                  </div>
                  <div className="gridItem">
                    <span>{leftSealed != null ? `${leftSealed}m` : null}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="infoGrouping">
              <label>Sealed Lanes</label>
              <div className="data">
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Total Seal Width</label>
                  </div>
                  <div className="gridItem">
                    <span>{sealWidth != null ? `${sealWidth}m` : null}</span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Lanes</label>
                  </div>
                  <div className="gridItem">
                    <span>{laneCount}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="infoGrouping">
              <label>Right Shoulder</label>
              <div className="data">
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Sealed</label>
                  </div>
                  <div className="gridItem">
                    <span>
                      {rightSealed != null ? `${rightSealed}m` : null}
                    </span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Unsealed</label>
                  </div>
                  <div className="gridItem">
                    <span>
                      {rightUnsealed != null ? `${rightUnsealed}m` : null}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="section" style={{ flexBasis: "8%" }}>
        {props.hazardRatingLoading ? (
          <div>Loading Data...</div>
        ) : (
          <>
            <div className="infoGrouping">
              <label>Hazard Rating</label>
              <div className="data">
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Left</label>
                  </div>
                  <div className="gridItem">
                    <span>{leftHazardRating}</span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Right</label>
                  </div>
                  <div className="gridItem">
                    <span>{rightHazardRating}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="section" style={{ flexBasis: "45%" }}>
        {props.alignmentDetailsLoading ? (
          <div>Loading Data...</div>
        ) : (
          <>
            <div className="infoGrouping">
              <label>Alignment</label>
              <div className="data">
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Vertical Curve Type</label>
                  </div>
                  <div className="gridItem" style={{ fontSize: "0.85em" }}>
                    <span>{verticalCurveType}</span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Grade</label>
                  </div>
                  <div className="gridItem" style={{ fontSize: "0.85em" }}>
                    <span>
                      {gradePercent != null ? `${gradePercent}%` : null}
                    </span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Vertical Design Speed</label>
                  </div>
                  <div
                    className={classNames("gridItem", {
                      highlight:
                        verticalDesignSpeed != null &&
                        props.speedLimit != null &&
                        props.speedLimit > verticalDesignSpeed,
                    })}
                  >
                    <span>
                      {verticalDesignSpeed != null
                        ? `${verticalDesignSpeed}km/h`
                        : null}
                    </span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Horizontal Profile</label>
                  </div>
                  <div className="gridItem">
                    <span>{horizontalProfile}</span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Curve Radius</label>
                  </div>
                  <div className="gridItem">
                    <span>
                      {curveRadius != null ? `${curveRadius}m` : null}
                    </span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Calculated Safe Speed</label>
                  </div>
                  <div
                    className={classNames("gridItem", {
                      highlight:
                        calculatedSafeSpeed != null &&
                        props.speedLimit != null &&
                        props.speedLimit > calculatedSafeSpeed,
                    })}
                  >
                    <span>
                      {calculatedSafeSpeed != null
                        ? `${calculatedSafeSpeed}km/h`
                        : null}
                    </span>
                  </div>
                </div>
                <div className="verticalGrid">
                  <div className="gridItem">
                    <label>Crossfall</label>
                  </div>
                  <div className="gridItem">
                    <span>{crossfall}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
